import React from "react";
import { useTranslation } from "react-i18next";
import tw, { css } from "twin.macro";

import { BookMeeting } from "../../components/BookMeeting";
import { Container } from "../../components/Container";
import AgencyServicesCards from "./AgencyServices/AgencyServicesCards";

const cards = css`
  ${tw`py-8 max-w-5xl mx-auto flex flex-wrap items-center`}
  .perfectResources {
    ${tw`text-4xl text-center font-black w-full mt-10`}
  }
`;

const AgencyServices: React.FC = ({ ...rest }) => {
  const { t } = useTranslation();
  return (
    <Container {...rest}>
      <section css={cards} id="agency-services">
        <AgencyServicesCards />
        <p className="perfectResources">{t("AgencyServices.perfectResources")}</p>
        <BookMeeting commentFirst={true} />
      </section>
    </Container>
  );
};

export default AgencyServices;
